import { render, staticRenderFns } from "./TextActionItem.vue?vue&type=template&id=6a7d2fd5&"
import script from "./TextActionItem.vue?vue&type=script&lang=js&"
export * from "./TextActionItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports